import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AdvancedDataSource } from 'src/app/controls/advanced-gridview/datasources/advanced-datasource';
import { AdvancedGridviewModel } from 'src/app/controls/advanced-gridview/models/advanced-gridview-model';
import { ColumnDefinition } from 'src/app/controls/advanced-gridview/models/column-definition';
import { ColumnType } from 'src/app/controls/advanced-gridview/models/column-type';
import { Context } from 'src/app/controls/advanced-gridview/models/context';
import { MenuITemAction } from 'src/app/controls/advanced-gridview/models/menu-item-action';
import { MenuItemEvent } from 'src/app/controls/advanced-gridview/models/menu-item-event';
import { SortInfos } from 'src/app/controls/advanced-gridview/models/sort-infos';
import { FilterType } from 'src/app/controls/filters/models/filter-type';
import { DefaultListComponent } from 'src/app/controls/list/default-list/default-list.component';
import { EnumHelper } from 'src/app/helpers/enum-helper';
import { Rights } from 'src/app/models/enums/rights';
import { SmsTemplate } from 'src/app/models/sms-template';
import { MemoryService } from 'src/app/services/memory.service';
import { NotificationService } from 'src/app/services/notification-service';
import { SmsTemplatesService } from 'src/app/services/sms-templates.service';
import { AdvancedGridviewComponent } from '../../../controls/advanced-gridview/advanced-gridview.component';

@Component({
    selector: 'app-sms-templates-list',
    imports: [AdvancedGridviewComponent],
    templateUrl: './sms-templates-list.component.html',
    styleUrl: './sms-templates-list.component.scss'
})
export class SmsTemplatesListComponent extends DefaultListComponent<SmsTemplate> implements OnInit {
    /**
     * Configuration des colonnes de la liste.
     */
    tableConfig: ColumnDefinition[] = null;

    @Input()
    public global: boolean;

    /**
     * Constructeur
     * @param dialog : Service pour ouvrir des boites de dialogue.
     * @param memoryService : Service pour récupérer les informations en mémoire.
     * @param enumHelper : Classe utilitaire pour les énumérations.
     * @param smsTemplatesService : Service de gestion des templates de SMS.
     */
    constructor(
        public override dialog: MatDialog,
        protected override memoryService: MemoryService,
        public enumHelper: EnumHelper,
        private smsTemplatesService: SmsTemplatesService,
        private spinner: NgxSpinnerService,
        private notificationService: NotificationService
    ) {
        super(dialog, memoryService);

        // Specifie des colonnes en fonction des droits utilisateurs
        if (this.memoryService.getConnectedUser().params.idVisible === true) {
            this.tableConfig = [
                new ColumnDefinition('id', 'Id', ColumnType.Numeric, FilterType.Text, 1, 5, true),
                new ColumnDefinition('name', 'Nom', ColumnType.Text, FilterType.Text, 2, 90, true),
            ];
        } else {
            this.tableConfig = [new ColumnDefinition('name', 'Nom', ColumnType.Text, FilterType.Text, 2, 95, true)];
        }

        // Spécifie les éléments du menu contextuel en fonction des droits utilisateur
        this.AddMenuItem('Dupliquer', MenuITemAction.Duplicate, Rights.SmsTemplateCreate);
        this.AddMenuItem('Éditer', MenuITemAction.Update, Rights.SmsTemplateEdit);
        this.AddMenuItem('Supprimer', MenuITemAction.Delete, Rights.SmsTemplateDelete);
    }

    /**
     * Initialise le composant.
     */
    ngOnInit(): void {
        let context: Context;

        if (this.global === true) {
            context = null;
        } else {
            context = { property: 'viewId', value: this.memoryService.getSelectedView().id };
        }
        console.log(`SmsTemplatesListComponent --> global : ${this.global}`);
        this.dataSource = new AdvancedDataSource(context, this.smsTemplatesService, this.spinner, this.notificationService);
        this.filteredTableModel = new AdvancedGridviewModel(this.tableConfig, new SortInfos('name', 'asc'));
    }

    /**
     * Appellé lorsque l'utilisateur clique sur un élément du menu contextuel.
     * @param event : Événement retourné par le menu contextuel.
     */
    public onAction(event: MenuItemEvent<SmsTemplate>): void {
        if (event.action == MenuITemAction.Read) {
            // Cas de la consultation.
            this.itemDisplayed.emit(event.context);
        } else if (event.action == MenuITemAction.Update) {
            // Cas de la mise à jour.
            this.itemEdited.emit(event.context);
        } else if (event.action == MenuITemAction.Duplicate) {
            // Cas de duplication.
            this.itemDuplicated.emit(event.context);
        } else if (event.action == MenuITemAction.Delete) {
            // Cas de la suppression --> affichage de la boite de dialogue de confirmation.
            this.displayDeleteConfirmationDialog(`Vous êtes sur le point de supprimer le modèle de SMS '${event.context.name}'.`, event.context);
        }
    }
}
